/* import __COLOCATED_TEMPLATE__ from './reviewable-post-header.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./reviewable-post-header.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));